/**
 * useMyTaskCounts — the signed-in user's task bucket counts.
 *
 * The Dashboard's Pending Tasks badge and the sidebar's Tasks count both read
 * this one query, but different fields: the Dashboard reads `actionable` (it
 * lists upcoming tasks too), the sidebar reads `pastDue + dueToday` (only what
 * is due now). Keep
 * the key and params here: two call sites building `['dashboard-task-counts']`
 * with their own params would silently overwrite one shared cache entry.
 *
 * Invalidate `['dashboard-task-counts']` after any task write so every reader
 * refreshes.
 */
import { useQuery } from '@tanstack/react-query';
import { getTaskCounts } from '@/services/tasks.service';

export const MY_TASK_COUNTS_KEY = ['dashboard-task-counts'] as const;

export function useMyTaskCounts({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: MY_TASK_COUNTS_KEY,
    queryFn: () => getTaskCounts({ myOnly: true }),
    enabled,
    staleTime: 60_000,
    retry: false,
  });
}
